import {
  Box,
  Tab,
  Text
} from '@chakra-ui/react';
import Link from 'next/link';
import { Image } from '@/components/Image';
import { ReturnPageInfo } from '@/config/pages';

type ShopDetailTabsPcItemProps = {
  isActive: boolean;
  menuLink: ReturnPageInfo;
  isDisabledCourseTab: boolean;
  isDisabledStaffsTab: boolean;
  isDisabledMessageTab: boolean;
  isDisabledBlogTab: boolean;
  tabIcon: string;
  activeTabIcon: string;
  tabIconAlt: string;
  tabMenuTitle: string;
}

export const ShopDetailTabsPcItem = ({
  isActive = false,
  menuLink,
  activeTabIcon,
  tabIconAlt,
  isDisabledCourseTab,
  isDisabledStaffsTab,
  isDisabledMessageTab,
  isDisabledBlogTab,
  tabMenuTitle
}: ShopDetailTabsPcItemProps) => {
  const isDisabled = isDisabledCourseTab || isDisabledStaffsTab || isDisabledMessageTab || isDisabledBlogTab;

  return (
    <Box
      w={'25%'}
    >
      <Link
        href={menuLink.href}
      >
        <Tab
          _focus={{
            ring: '2px',
            ringColor: 'brand.500'
          }}
          cursor={'pointer'}
          bg={isActive ? 'white' : 'rgba(131, 173, 79, 0.2)'}
          color={'brand.500'}
          disabled={isDisabled}
          pointerEvents={isDisabled ? 'none' : 'auto'}
          fontWeight={'bold'}
          w={'full'}
          mr={'1px'}
        >
          <Box
            borderBottom={isActive ? '2px solid' : 'none'}
            display={'flex'}
            alignItems={'center'}
            py={1}
          >
            <Box
              textAlign={'center'}
              position={'relative'}
              w={30}
              h={30}
            >
              <Image
                src={activeTabIcon}
                alt={tabIconAlt}
                fill
                style={{ objectFit: 'contain' }}
              />
            </Box>
            <Text
              fontSize={{base: '1vw', xl: 'md'}}
              textAlign={'center'}
              whiteSpace={'pre-wrap'}
              pl={3}
            >
              {tabMenuTitle}
            </Text>
          </Box>
        </Tab>
      </Link>
    </Box>
  );
};
